import React from 'react';
import { connect } from 'react-redux';
import { provideLocalizationService, registerForLocalization } from '@progress/kendo-react-intl';
import { GridSize, Grid, InlineBadge } from '../../shared/components';
import { getGeneralCompetencyStatusThemeColor } from '../../../resources/generalCompetencyStatus';
import {
  loadClaimReviewListPage,
  findClaims,
  sortClaims
} from '../actions/claim-review-list-page-actions';
import { withRouter } from '../../../components/withRouter';

class ClaimReviewList extends React.PureComponent {

  constructor() {
    super();
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handleRowClick = this.handleRowClick.bind(this);
  }

  async componentDidMount() {
    await this.props.loadClaimReviewListPage();
  }

  render() {
    const localizationService = provideLocalizationService(this);
    return (
      <Grid
        loading={this.props.loading}
        data={this.props.claims}
        skip={this.props.skip}
        take={this.props.take}
        total={this.props.total}
        sort={this.props.sorting}
        onPageChange={this.handlePageChange}
        onSortChange={this.handleSort}
        onRowClick={this.handleRowClick}
        rowLink={(dataItem) => `/general_competency_claims/${dataItem.id}/overview`}
        columns={[
          {
            field: 'studentName',
            className: 'align-left',
            headerClassName: 'align-left',
            title: localizationService.toLanguageString('generalCompetencyClaimReview.studentName')
          },
          {
            field: 'title',
            className: 'align-left',
            headerClassName: 'align-left',
            title: localizationService.toLanguageString('generalCompetencyClaimReview.title')
          },
          {
            field: 'organizer',
            className: 'align-left',
            headerClassName: 'align-left',
            title: localizationService.toLanguageString('generalCompetencyClaimReview.organizer'),
            sortable: false
          },
          {
            field: 'occurredAt',
            className: 'align-left',
            headerClassName: 'align-left',
            title: localizationService.toLanguageString('generalCompetencyClaimReview.occurredAt'),
            minGridWidth: GridSize.small,
            format: '{0:yyyy-MM-dd}'
          },
          {
            field: 'minutes',
            className: 'align-right',
            headerClassName: 'align-right',
            title: localizationService.toLanguageString('generalCompetencyClaimReview.minutes'),
            minGridWidth: GridSize.small
          },
          {
            field: 'status',
            className: 'align-left',
            headerClassName: 'align-left',
            title: localizationService.toLanguageString('generalCompetencyClaimReview.status'),
            minGridWidth: GridSize.small,
            cell: (e) => this.renderStatus(e)
          },
          {
            field: 'createdOn',
            className: 'align-left',
            headerClassName: 'align-left',
            title: localizationService.toLanguageString('generalCompetencyClaimReview.createdOn'),
            minGridWidth: GridSize.small,
            format: '{0:yyyy-MM-dd}'
          }
        ]}
      />
    );
  }

  renderStatus(e) {
    const { className, dataItem } = e;
    return (
      <td className={className}>
        <InlineBadge themeColor={getGeneralCompetencyStatusThemeColor(dataItem.statusCode)}>
          {dataItem.status}
        </InlineBadge>
      </td>
    );
  }

  handleSort(e) {
    this.props.sortClaims(e.sort);
  }

  async handlePageChange(e) {
    await this.props.findClaims({ skip: e.page.skip, take: e.page.take });
  }

  handleRowClick(e) {
    this.props.navigate(`/general_competency_claims/${e.dataItem.id}/overview`);
  }
}

const mapStateToProps = state => ({
  loading: state.claimReviewListPage.loading,
  claims: state.claimReviewListPage.claims,
  skip: state.claimReviewListPage.skip,
  take: state.claimReviewListPage.take,
  total: state.claimReviewListPage.total,
  sorting: state.claimReviewListPage.sorting
});

const mapDispatchToProps = dispatch => ({
  loadClaimReviewListPage: () => dispatch(loadClaimReviewListPage()),
  findClaims: (payload) => dispatch(findClaims(payload)),
  sortClaims: (payload) => dispatch(sortClaims(payload))
});

registerForLocalization(ClaimReviewList);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ClaimReviewList));
